import { useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
// import { bannerAddEdit } from "../../../../services/bannersService";
import { toast } from "react-toastify";
import Select from "../../../form/select/Select";
import { useMutation } from "@tanstack/react-query";
import { paymentGetwayAddEdit } from "../../../../services/paymentGetwayService";

const validation = {
  name: { required: true, message: "Name is required" },
};

const ManagePaymentGetway = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
  });

  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
      });
    }
  }, [data]);

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        ...(data?._id && { id: data?._id }),
      };

      return await paymentGetwayAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        getResponse(res);
        return res;
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="h-full p-4">
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          <div className="relative col-span-6">
            <Select
              label={"Name"}
              placeholder="Select Name"
              selectedValue={values?.name}
              dropdownData={[
                { name: "Stripe", value: "stripe" },
                { name: "Paypal", value: "paypal" },
                { name: "Googlepay", value: "googlepay" },
                { name: "Applepay", value: "applepay" },
                { name: "Amazonpay", value: "amazonpay" },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "name", value: val } });
              }}
              {...formValidate(errors, "name")}
            />
          </div>
          <div className="relative col-span-6">
            <Select
              label={"Environment"}
              placeholder="Select Environment"
              selectedValue={values?.environment}
              dropdownData={[
                { name: "Production", value: "production" },
                { name: "Sandbox", value: "sandbox" },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "environment", value: val } });
              }}
              {...formValidate(errors, "environment")}
            />
          </div>
        </div>
        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType="submit"
              buttonLabel={"Save Payment"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
            <Button
              buttonLabel={"Cancel"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonFunction={close}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManagePaymentGetway;
